import { Directory } from "@capacitor/filesystem";
import write_blob from "capacitor-blob-writer";

export async function saveBlobAs(blob: Blob, fileName: string, mobile: boolean): Promise<string | void> {
    if (mobile) {
        return write_blob({
            path: fileName,
            directory: Directory.Documents,
            blob: blob,
            recursive: true,
        });
    }
    else {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = fileName;
        a.target = '_blank';
        a.click();
        URL.revokeObjectURL(a.href);
        Promise.resolve();
    }
}

